import React from 'react';

import { CeilingTrayGeometry } from '@paragon/layout';

import { ManualRenderModes } from '../../../../library/renderModes';
import { CeilingRenderMode } from '../../../../store/slices/visualOptionsSlice';
import { LayoutPolygonStyle } from '../../polygon-rendering/common/style';
import { LayoutPolygonCollection } from '../../polygon-rendering/LayoutPolygonCollection';
import { CeilingTrayEventHandlers } from './CeilingTrayEventHandlers';

interface Props {
  trayAndGeometry: CeilingTrayGeometry;

  style: LayoutPolygonStyle;
  mode: ManualRenderModes<CeilingRenderMode>;
}

export function CeilingTrayVisual({ trayAndGeometry: { tray, faces }, style, mode }: Props) {
  return (
    <CeilingTrayEventHandlers tray={tray}>
      <LayoutPolygonCollection style={style} mode={mode} polygons={faces} />
    </CeilingTrayEventHandlers>
  );
}
